import { CbhFeatureFlag, useCbhFlag } from "../../FeatureFlags";

export function useIsJobsRedirectionEnabled() {
  return useCbhFlag(CbhFeatureFlag.ENABLE_JOBS_MAP_VIEW_REDIRECTION, {
    defaultValue: false,
  });
}
